<template>
  <div class="card">
    <div class="card-header bg-primary">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="card-title mb-0 text-white">Jadwal Tersedia</h4>
        <date-picker
          v-model="date"
          type="date"
          input-class="form-control"
          placeholder="Select date"
          :format="'YYYY-MM-DD'"
          :disabled-date="disableDate"
          :clearable="false"
          @input="showChart"
        >
        </date-picker>
      </div>
    </div>
    <div class="card-body content-board pt-0 px-0 vld-parent">
      <loading
        :active.sync="isLoading"
        :is-full-page="false"
        :height="45"
        :width="45"
        color="#398BD7"
      ></loading>
      <div class="row">
        <div class="col-12">
          <ul class="list-group list-group-flush mt-1" v-if="status == true">
            <li class="list-group-item list-group-item-action" v-for="(item, index) in data" :key="index">
              <div class="d-flex align-items-center justify-content-between">
                <template v-if="item == 0">
                  <h6 style="color:#ccc !important" class="list-title mb-0">{{ index }}</h6>
                  <p style="color:#ccc !important">{{ item }} Slot</p>
                </template>
                <template v-else>
                  <h6 class="list-title mb-0">{{ index }}</h6>
                  <p>{{ item }} Slot</p>
                </template>
              </div>
            </li>
          </ul>
          <ul class="list-group list-group-flush mt-1" v-else-if="status == false">
            <li class="list-group-item list-group-item-action text-center">
              <h5>Libur</h5>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_module: "dashboards",
      date: this.$moment().add(1, 'days').toDate(),
      isLoading: true,
      data : [],
      status : null
    };
  },
  mounted() {
    this.showChart();
  },
  methods: {
    filterSelect() {
      this.showChart();
    },
    showChart() {
      this.isLoading = true;
      let params = {};

      params["srv_t_date"] = this.$moment(this.date).format("YYYY-MM-DD");

      this.axios
        .post("/" + this.table_module + "/checkScheduleWidget", params)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data.dashboards
          this.status = response.data.data.dashboards_status
        });
    },
    disableDate(date){
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date <= today;
    }
  },
};
</script>

<style scoped>
.card-body{
  max-height: 500px;
  overflow-y: auto;
}
</style>